import { DynamicController } from "../../../Controls/Dynamic/DynamicController";
import { BaseControl } from "../../../Controls/Dynamic/BaseControl";
import { IVisibilityConditionControl } from "../../../Controls/Dynamic/IVisibilityConditionControl";
import { Template } from "../../../Areas/Admin/Measures/TemplateEdit/Models/Template";
import { IFieldAndValueModel } from "./IFieldAndValueModel";

export class Condition implements IFieldAndValueModel {
    pos: number;
    operator: string;
    value: string;
    dateValue: string;
    boolValue?: boolean;
    nextLink: string;
    fieldId: number;
    categoryId: number;
    isSubCategory: boolean;
    fieldGuid: string;
    fieldUniqueId: string;
    fieldString: string;
    fieldType: string;
    fieldName: string;
    me: number;
    gridName: string;
    gridCondition: string;
    compareField?: boolean;
    compareFieldIdentifier?: string;

    // Not serialized properties
    public friendlyValue: string;

    dynController: DynamicController;
    control: BaseControl;
    measureField: string;

    constructor() {

    }

    public initialize(dynController: DynamicController) {
        this.dynController = dynController;

        if (this.categoryId) {
            if (this.categoryId != 0) {
                if (this.dynController.isMultiCategory(this.categoryId)) {
                    this.control = this.dynController.getMultiCategory(this.categoryId);
                } else {
                    this.control = dynController.getCategoryControl(this.categoryId);
                }
            }
        } else {
            this.control = this.dynController.getControlOrCategory(this.fieldId);
        }

        if (!this.control) {
            // Try to initialize using standard measure fields

            //console.log("Condition.initialize: unknown control: " + this.fieldId);
        }
    }

    public isTrue(standardFieldsData: any): boolean {
        if (this.control) {
            if ("isConditionTrue" in this.control) {
                return (this.control as IVisibilityConditionControl).isConditionTrue(this.operator, this.value, this.dateValue, this.me);
            }
        } else if (standardFieldsData && standardFieldsData[this.measureField]) {
            // All currently allowed fields of the measure are of type int.
            // If any other fields are allowed to be used in conditions, this has to be extended with comparisons
            // for other types.
            let compareField = this.measureField;
            if (this.measureField == "StatusEBlockId")
                compareField = this.measureField + "_Id";

            switch (this.operator) {
                case "=":
                    if (this.value == standardFieldsData[compareField]) {
                        return true;
                    }
                    break;
                case "<>":
                    if (this.value != standardFieldsData[compareField]) {
                        return true;
                    }
                    break;
                case "<=":
                    if (this.value <= standardFieldsData[compareField]) {
                        return true;
                    }
                    break;
                case ">=":
                    if (this.value >= standardFieldsData[this.measureField]) {
                        return true;
                    }
                case "<":
                    if (this.value < standardFieldsData[this.measureField]) {
                        return true;
                    }
                    break;
                case ">":
                    if (this.value > standardFieldsData[this.measureField]) {
                        return true;
                    }
                    break;
                case "null":
                    if (standardFieldsData[this.measureField] == null || standardFieldsData[this.measureField] == undefined) {
                        return true;
                    }
                    break;
            }
            
        }
        return false;
    }

    private isDateTrue(value: any): boolean {
        let compareToValue: Date;
        if (value) {
            let str: string = value.toString();
            let split = str.split(".");
            if (split.length == 3) {
                compareToValue = new Date(split[2] + "-" + split[1] + "-" + split[0] + "T00:00:00");
            }
        }

        let ownValue: Date;
        if (this.dateValue)
            ownValue = new Date(this.dateValue);

        if (ownValue && compareToValue) {
            switch (this.operator) {
                case "=":
                    return ownValue.getTime() === compareToValue.getTime();

                case "<>":
                    return ownValue.getTime() !== compareToValue.getTime();

                case ">":
                    return compareToValue.getTime() > ownValue.getTime();

                case "<":
                    return compareToValue.getTime() < ownValue.getTime();

                case ">=":
                    return compareToValue.getTime() >= ownValue.getTime();

                case "<=":
                    return compareToValue.getTime() <= ownValue.getTime();
            }
        }
        return false;
    }


    private isDoubleTrue(value: any): boolean {
        let compareToValue: number = 0;
        if (value)
            compareToValue = parseFloat(value);

        let ownValue: number = 0;
        if (this.value)
            ownValue = parseFloat(this.value);

        switch (this.operator) {
            case "=":
                return ownValue == compareToValue;

            case "<>":
                return ownValue != compareToValue;

            case ">":
                return compareToValue > ownValue;

            case "<":
                return compareToValue < ownValue;

            case ">=":
                return compareToValue >= ownValue;

            case "<=":
                return compareToValue <= ownValue;
        }
        return false;
    }

    getGridCondition = (template: Template) => {
        if (!this.fieldName) {
            var field = template.fields.items.find(f => f.guid == this.fieldGuid);
            if (field) {
                this.fieldName = field.name;
            } else {
                this.fieldName = Resources.Common.null;
            }
        }

        return `${this.fieldName} ${this.operator} ${this.friendlyValue}`;
    }

    public static copy(from: Condition, to: Condition) {
        to.pos = from.pos;
        to.operator = from.operator;
        to.value = from.value;
        to.dateValue = from.dateValue;
        to.nextLink = from.nextLink;
        to.fieldId = from.fieldId;
        to.fieldGuid = from.fieldGuid;
        to.fieldString = from.fieldString;
        to.fieldType = from.fieldType;
        to.fieldName = from.fieldName;
        to.me = from.me;
        to.gridName = from.gridName;
        to.categoryId = from.categoryId;
        to.friendlyValue = from.friendlyValue;
    }
}